import { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

const NONE = "__none__";
let cache = null;

export function useGrades() {
  const [grades, setGrades] = useState(cache || []);
  useEffect(() => { api.get("/grades").then((r) => { cache = r.data; setGrades(r.data); }).catch(() => {}); }, []);
  return grades;
}

export const GradeBadge = ({ value, testId }) => (!value ? null : (
  <span className="ml-1.5 inline-flex items-center gap-0.5 text-[10px] font-semibold rounded-full px-1.5 py-0.5 border align-middle bg-violet-50 text-violet-700 border-violet-200" data-testid={testId}>
    <Award className="h-3 w-3" />Grade {value}
  </span>
));

export function GradeSelect({ value, onChange, testId = "select-grade", compact = false, className = "" }) {
  const grades = useGrades();
  return (
    <div className="space-y-1.5">
      {!compact && <Label>Grade <span className="text-slate-400 font-normal">opsional</span></Label>}
      <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
        <SelectTrigger className={`${compact ? "h-9" : ""} ${className}`} data-testid={testId}><SelectValue placeholder="Grade" /></SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>— Tanpa grade</SelectItem>
          {grades.map((g) => <SelectItem key={g.id} value={g.name}>{g.name}{g.description ? ` — ${g.description}` : ""}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
